import React from 'react';
import { useNavigate } from 'react-router-dom';
import GenericEntityList from '../../components/Common/GenericEntityList';

const SignalManagement: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateSignal = () => {
    navigate('/signals/create');
  };

  return (
    <GenericEntityList
      entityType="signal"
      detailsRoute="/signals"
      onCreateClick={handleCreateSignal}
      createButtonLabel="Add Signal"
      showCreateButton={true}
      showExportButton={true}
    />
  );
};

export default SignalManagement;

